<template>
  <button @click="$emit('click')" :disabled="disabled" :class="typeClass"><slot></slot></button>
</template>

<script>
import { props } from './BaseButton.js'
export default {
  props,
  computed: {
    typeClass () {
      return `type${this.type}`
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
button {
  cursor: pointer;
  outline: 0;
  text-align: center;
  &.type0 {
    background-color: var(--colorMain);
    color: var(--colorWhite);
    border: 0;
    &:active,
    &[data-active="true"] {
      /* 按下或触摸时，正常按钮色值里的 HSB的B 数值调为75% */
      /* https://github.com/postcss/postcss-color-function#list-of-color-adjuster */
      background-color: color(var(--colorMain) blackness(25%));
    }
    &:disabled,
    &[data-disabled="true"] {
      background-color: var(--colorDisabled);
    }
  }
  &.type1 {
    background-color: var(--color8);
    color: var(--colorWhite);
    border: 0;
    &:active,
    &[data-active="true"] {
      background-color: rgba(103,136,243,1);
    }
    &:disabled,
    &[data-disabled="true"] {
      background-color: var(--colorDisabled);
    }
  }
  &.type2 {
    background-color: var(--colorWhite);
    color: var(--colorMain);
    border: 1px solid var(--colorMain);
    &:active,
    &[data-active="true"] {
      background-color: rgb(243, 243, 243);
    }
    &:disabled,
    &[data-disabled="true"] {
      border: 0;
      background-color: var(--colorDisabled);
      color: var(--colorWhite);
    }
  }
  &.type3 { /* static gray */
    background-color: var(--color8);
    border-color: var(--color8);
    color: var(--color7);
  }
  &.type4 { /* static white */
    background-color: var(--colorWhite);
    border-color: var(--colorDisabled);
    color: var(--color5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/button/BaseButton.vue